const styles = `:host {
  --goto-icon-size: 24px;
  display: flex;
  outline: 0;
}
:host button {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: 4px;
  white-space: normal;
  color: var(--goto-link);
  --goto-icon-color: var(--goto-link);
  border-color: var(--goto-interactive-02);
  background-color: var(--goto-interactive-02);
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  font: var(--goto-button-text-medium);
  padding: 0;
  --goto-icon-color: var(--goto-icon-button-icon-color, var(--goto-icon-01));
}
:host button [part=content] {
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
:host button:hover {
  border-color: transparent;
  background-color: var(--goto-hover-secondary);
}
:host button:active {
  border-color: transparent;
  background-color: var(--goto-pressed-tertiary);
  box-shadow: none;
}
:host button:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host button:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host button:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-interactive-02);
  box-shadow: none;
  cursor: default;
  --goto-icon-color: var(--goto-disabled-04);
}

:host([size=xsmall]) {
  --goto-icon-size: 18px;
}
:host([size=xsmall]) button {
  height: 24px;
  width: 24px;
}

:host([size=small]) {
  --goto-icon-size: 20px;
}
:host([size=small]) button {
  height: 30px;
  width: 30px;
}

:host([size=large]) {
  --goto-icon-size: 30px;
}
:host([size=large]) button {
  height: 42px;
  width: 42px;
}

:host([variant=secondary]) button {
  --goto-icon-color: var(--goto-text-02);
}

:host([variant=neutral]) button {
  --goto-icon-color: var(--goto-text-01);
}

:host([disabled]) .content {
  pointer-events: none;
}`; export default styles;